<template>
<v-text-field outlined v-model="difference" :rules="rules" :label="$t('configurations.report_difference')"></v-text-field>
</template>

<script>
export default {
  name: 'ReportDifferenceTextField',
  props: {
    value: {
      type: Number
    }
  },
  data() {
    return {
      range: [0.1, 100],
      rules: [
        v => !!v || this.$t('configurations.this_is_required'),
        v => parseFloat(v) <= this.range[1] || this.$t('configurations.max_is', {
          val: this.range[1]
        }),
        v => parseFloat(v) >= this.range[0] || this.$t('configurations.min_is', {
          val: this.range[0]
        })
      ]
    }
  },
  computed: {
    difference: {
      get() {
        return this.value || '';
      },
      set(val) {
        this.$emit('input', parseFloat(val));
      }
    }
  }
}
</script>
